import { NO_VIEWPORT_TYPE } from './types.js';
const DEFAULT_VIEWPORT_TYPES = ['stack'];
export function isDisplayableViewportTypes(viewportTypes) {
    return !viewportTypes.includes(NO_VIEWPORT_TYPE);
}
export function getViewportTypesForRule(rule) {
    if (rule.viewportTypes?.length) {
        return rule.viewportTypes;
    }
    return DEFAULT_VIEWPORT_TYPES;
}
export function getPreferredViewportType(viewportTypes) {
    return viewportTypes[0] ?? 'stack';
}
export function getViewportTypesForGroup(group) {
    return getViewportTypesForRule(group.matchedRule);
}
